import Api from './Api';
import Csrf from './Csrf';


const AccessCode = {

    async queryAccessCode(form_items) {
        await Csrf.getCookie();
        return Api.post('/access_codes/query', form_items);
    }

};

export default AccessCode;